import { usePurchaseImportFileContext } from '@/pages/MovementsPage/PurchaseImportPage/PurchaseImportFileProvider';
import { currencyFormatter } from '@/utils/number';
import { Descriptions } from 'antd';
import moment from 'moment';

export default function ConfirmImportDescriptions() {
  const { purchaseImportData, companyIdSelected } =
    usePurchaseImportFileContext();

  const companyName = companyIdSelected
    ? purchaseImportData?.companies.find(
        (company) => company.id === companyIdSelected,
      )?.name
    : purchaseImportData?.companies?.at(-1)?.name;

  return (
    <Descriptions
      bordered
      layout="vertical"
      labelStyle={{ fontWeight: 'bold' }}
      size="small"
      column={{ lg: 16, xs: 4, md: 12, sm: 8, xl: 24, xxl: 24 }}
      style={{ marginBottom: 24 }}
    >
      <Descriptions.Item label="Empresa" span={8}>
        {companyName || '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Chave Nota Fiscal" span={8}>
        {purchaseImportData?.keyNfe || '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Fornecedor" span={8}>
        {purchaseImportData?.supplierDTO.name || '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Número da Nota Fiscal" span={4}>
        {purchaseImportData?.documentNumber || '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Modelo" span={4}>
        {purchaseImportData?.modelNf || '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Série" span={4}>
        {purchaseImportData?.seriesNf || '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Data de emissão" span={4}>
        {purchaseImportData?.issueDate
          ? moment(purchaseImportData.issueDate).format('DD/MM/YYYY')
          : '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Data de saída" span={4}>
        {purchaseImportData?.departureDate
          ? moment(purchaseImportData.departureDate).format('DD/MM/YYYY')
          : '-'}
      </Descriptions.Item>

      <Descriptions.Item label="Valor da Nota Fiscal" span={4}>
        {purchaseImportData?.totalAmount
          ? currencyFormatter(purchaseImportData.totalAmount)
          : '-'}
      </Descriptions.Item>
    </Descriptions>
  );
}
